<template>
  <div class="home">
    <div class="header">
      <a class="logo" href="/">
        <div class="text">冰墩墩表情生成器</div>
      </a>
      <div class="author">
        <a href="https://thuscn.com/lab/" target="_blank">
          by
          <div class="author-name">
            <svg
              width="85"
              height="24"
              viewBox="0 0 412 115"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>ThusLab</title>
              <path
                d="M57.5 39.2H37.6V93H22V39.2H2V28.1H57.5V39.2ZM112.573 93H97.9727V59.2C97.9727 56.5333 97.506 54.7667 96.5727 53.9C95.706 53.0333 93.5727 52.6 90.1727 52.6C85.9727 52.6 83.306 53.0333 82.1727 53.9C81.0393 54.7 80.4727 56.4667 80.4727 59.2V93H65.8727V23H80.4727V50.5C81.406 45.9 86.506 43.6 95.7727 43.6C102.173 43.6 106.573 44.7667 108.973 47.1C111.373 49.3667 112.573 52.8333 112.573 57.5V93ZM172.045 93H157.645V87.1C156.512 91.7 151.345 94 142.145 94C135.745 94 131.345 92.8667 128.945 90.6C126.545 88.2667 125.345 84.7667 125.345 80.1V44.6H139.945V78.1C139.945 80.7667 140.379 82.5667 141.245 83.5C142.179 84.4333 144.345 84.9 147.745 84.9C151.945 84.9 154.612 84.4667 155.745 83.6C156.879 82.6667 157.445 80.8333 157.445 78.1V44.6H172.045V93ZM226.518 74.1V80.2C226.518 82.6 226.051 84.6667 225.118 86.4C224.251 88.1333 223.118 89.5 221.718 90.5C220.385 91.4333 218.618 92.1667 216.418 92.7C214.218 93.2333 212.085 93.5667 210.018 93.7C208.018 93.9 205.651 94 202.918 94C197.651 94 191.285 93.5 183.818 92.5V82.8C193.085 84.2 199.518 84.9 203.118 84.9C205.985 84.9 208.185 84.6333 209.718 84.1C211.318 83.5 212.118 82.3667 212.118 80.7V77.7C212.118 76.1667 211.685 75.0333 210.818 74.3C209.951 73.5 208.085 73.1 205.218 73.1H198.918C193.851 73.1 189.885 72.1 187.018 70.1C184.218 68.0333 182.818 65.0333 182.818 61.1V55.2C182.818 50.8 184.918 47.7667 189.118 46.1C193.318 44.4333 199.251 43.6 206.918 43.6C210.118 43.6 215.851 43.9 224.118 44.5V53.8C213.718 53 207.851 52.6 206.518 52.6C202.451 52.6 199.885 52.9 198.818 53.5C197.751 54.0333 197.218 55.1 197.218 56.7V59.3C197.218 60.1 197.618 60.8333 198.418 61.5C199.285 62.1667 200.585 62.5 202.318 62.5H208.718C220.585 62.5 226.518 66.3667 226.518 74.1Z"
                fill="#333"
              />
              <path
                d="M290.5 93H243V28.1H258.6V81.9H290.5V93ZM344.008 93H329.708V88.6C328.641 90.5333 327.108 91.9333 325.108 92.8C323.108 93.6 319.441 94 314.108 94C307.574 94 303.241 93 301.108 91C298.974 89 297.908 84.8333 297.908 78.5C297.908 72.7667 299.008 68.8 301.208 66.6C303.408 64.3333 307.341 63.2 313.008 63.2H329.408V59.9C329.408 56.9667 328.708 55.0333 327.308 54.1C325.974 53.1 323.108 52.6 318.708 52.6C314.574 52.6 308.908 53 301.708 53.8V44.6C307.241 43.9333 313.408 43.6 320.208 43.6C329.141 43.6 335.341 44.7 338.808 46.9C342.274 49.0333 344.008 53.3 344.008 59.7V93ZM329.408 80.6V71.2H319.408C316.208 71.2 314.208 71.5667 313.408 72.3C312.608 73.0333 312.208 75 312.208 78.2C312.208 81.3333 312.608 83.2333 313.408 83.9C314.274 84.5667 316.408 84.9 319.808 84.9C321.474 84.9 322.708 84.9 323.508 84.9C324.308 84.8333 325.174 84.7333 326.108 84.6C327.041 84.4667 327.674 84.2667 328.008 84C328.408 83.6667 328.741 83.2333 329.008 82.7C329.274 82.1667 329.408 81.4667 329.408 80.6ZM406.453 59.9V75.8C406.453 82.4 404.453 87.1 400.453 89.9C396.52 92.6333 390.153 94 381.353 94C372.086 94 365.686 92.5667 362.153 89.7C358.62 86.7667 356.853 82.1333 356.853 75.8V23H371.453V49.4C372.32 47.2 373.92 45.7 376.253 44.9C378.653 44.0333 382.286 43.6 387.153 43.6C391.286 43.6 394.653 43.9333 397.253 44.6C399.853 45.2667 401.82 46.3667 403.153 47.9C404.486 49.3667 405.353 51 405.753 52.8C406.22 54.6 406.453 56.9667 406.453 59.9ZM391.853 77.7V59.8C391.853 56.6667 391.253 54.7 390.053 53.9C388.92 53.0333 386.053 52.6 381.453 52.6C377.32 52.6 374.62 53.1333 373.353 54.2C372.086 55.2667 371.453 57.1333 371.453 59.8V77.7C371.453 80.5667 372.053 82.5 373.253 83.5C374.52 84.4333 377.286 84.9 381.553 84.9C385.82 84.9 388.586 84.4333 389.853 83.5C391.186 82.5 391.853 80.5667 391.853 77.7Z"
                fill="#333"
              />
            </svg>
          </div>
        </a>
      </div>
    </div>

    <div class="bdd-maker">
      <div class="maker-preview">
        <div id="avatarmaker" class="preview-content">
          <img :src="img" alt="" />
          <div class="text" v-html="parsedBody" :class="textColor"></div>
        </div>
      </div>

      <div class="maker-tool">
        <div class="hot-list">
          <ul>
            <li v-for="(item, index) in list" :key="item.img">
              <input
                type="radio"
                name="avatarMaskStyle"
                :id="'mask' + index"
                v-on:change="changeStyle"
                :title="index"
                v-model="hot"
                :value="index"
              />
              <label :for="'mask' + index">
                <img :src="item.img" alt="" />
              </label>
            </li>
          </ul>
        </div>

        <div class="text-editor">
          <div class="text">
            <textarea
              name=""
              id=""
              cols="30"
              rows="2"
              placeholder="请输入"
              v-model="text"
            ></textarea>
          </div>
          <div class="colors">
            <div class="color-item">
              <input
                type="radio"
                name="textColor"
                v-model="textColor"
                value="color01"
                id="color01"
                checked
              />
              <label for="color01" class="color01">
                <svg
                  class="icon"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                >
                  <path
                    d="M389.7 604.3 198.2 447.4c-3.7-3-9.1-3-12.8.1l-73.3 61.4c-4.4 3.7-4.8 10.3-.9 14.5l324.1 344.3c5 5.3 13.8 3.6 16.6-3.1 64.4-160.1 244.3-452.8 463.2-664.7 3-2.9 3.9-7.2 2.3-11l-13.7-33c-2.4-5.8-9.5-8-14.7-4.5-243.2 157.7-419.4 353.5-499.3 452.9z"
                    fill="#fff"
                  />
                </svg>
              </label>
            </div>
            <div class="color-item">
              <input
                type="radio"
                name="textColor"
                v-model="textColor"
                value="color02"
                id="color02"
              />
              <label for="color02" class="color02">
                <svg
                  class="icon"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                >
                  <path
                    d="M389.7 604.3 198.2 447.4c-3.7-3-9.1-3-12.8.1l-73.3 61.4c-4.4 3.7-4.8 10.3-.9 14.5l324.1 344.3c5 5.3 13.8 3.6 16.6-3.1 64.4-160.1 244.3-452.8 463.2-664.7 3-2.9 3.9-7.2 2.3-11l-13.7-33c-2.4-5.8-9.5-8-14.7-4.5-243.2 157.7-419.4 353.5-499.3 452.9z"
                    fill="#000"
                  />
                </svg>
              </label>
            </div>
          </div>
        </div>

        <div class="tool-footer">
          <div class="download">
            <button
              class="download-btn"
              @click="generatorImageDialog"
              v-if="Mobile"
            >
              下载表情
            </button>
            <button class="download-btn" @click="generatorImage" v-else>
              下载表情
            </button>
          </div>
          <div class="share">
            <button @click="share" :disabled="disable">
              <b>😍</b> 推荐给朋友
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="wx-mp">
        <a v-if="selected" :href="selected.url" target="_blank"
          ><img :src="selected.img" alt=""
        /></a>
      </div>
      <p>
        免责声明：本网站所有表情均来自网络，仅供学习参考，如有侵权，请联系我们删除。
        <br />请遵守当地法律法规，违者后果自负。
      </p>
      <ul>
        <li>
          <a target="_blank" href="https://hu.lvwzhen.com/">虎年头像生成器</a>
        </li>
        <li><a @click="showTips">隐私说明</a></li>
        <li>
          <a target="_blank" href="https://support.qq.com/products/380382"
            >意见反馈</a
          >
        </li>
        <li>
          <a target="_blank" href="https://twitter.com/lvwzhen">联系作者</a>
        </li>
      </ul>
    </div>

    <van-dialog
      v-model="avatarmakerDialog"
      class="avatarmaker-dialog"
      show-cancel-button
      cancelButtonText="关闭"
      :showConfirmButton="false"
    >
      <div class="avatarmaker-pic">
        <img :src="output" v-if="output" />
        <div class="tips">长按保存图片</div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="tipsDialog"
      class="tips-dialog"
      show-cancel-button
      cancelButtonText="关闭"
      :showConfirmButton="false"
    >
      <div class="content">
        「冰墩墩表情生成器」的图片生成功能仅依赖于本地浏览器，我们不会在服务器中储存或者收集用户的数据和图片。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import Vue from "vue";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";
import domtoimage from "dom-to-image";
Vue.use(Toast);
Vue.use(Dialog);

export default {
  data() {
    return {
      hot: 0,
      textColor: "color01",
      text: "吃了吗 您呐😊",
      img: require("../assets/img/1.jpg"),
      avatarmakerImg: null,
      tipsDialog: false,
      output: null,
      msg: "冰墩墩表情生成器：https://bdd2022.com/",
      list: [
        {
          img: require("../assets/img/1.jpg"),
          text: "吃了吗 您呐😊",
        },
        {
          img: require("../assets/img/2.jpg"),
          text: "溜了溜了",
        },
        {
          img: require("../assets/img/3.jpg"),
          text: "🚗 滴滴 快上车",
        },
        {
          img: require("../assets/img/4.jpg"),
          text: "别逼我动手",
        },
        {
          img: require("../assets/img/5.jpg"),
          text: "来咯来咯 我来咯",
        },
        {
          img: require("../assets/img/6.jpg"),
          text: "反了你 😠",
        },
        {
          img: require("../assets/img/7.jpg"),
          text: "你瞅啥？",
        },
        {
          img: require("../assets/img/8.jpg"),
          text: "来自大佬的凝视😎",
        },
        {
          img: require("../assets/img/9.jpg"),
          text: "火速赶往现场",
        },
        {
          img: require("../assets/img/10.jpg"),
          text: "躺赢",
        },
        {
          img: require("../assets/img/11.jpg"),
          text: "匍匐前进",
        },
        {
          img: require("../assets/img/12.jpg"),
          text: "不许动 举起手来",
        },
        {
          img: require("../assets/img/13.jpg"),
          text: "自由飞翔",
        },
        {
          img: require("../assets/img/14.jpg"),
          text: "你是要上天呀",
        },
        {
          img: require("../assets/img/15.jpg"),
          text: "走你",
        },
      ],
      avatarmakerDialog: false,
      disable: false,
      previewImage: null,
      Mobile: false,
      disabled: false,
      projects: [
        {
          url: "https://mp.weixin.qq.com/s/ei9CYh6zZ5co0d6hP78RSA",
          img: "https://cam.lvwzhen.com/project/coldplay-weekly.png",
        },
        {
          url: "weixin://dl/business/?t=p0pwI8Z8ljm",
          img: "https://cam.lvwzhen.com/project/1024.png",
        },
        {
          url: "https://www.zhihu.com/column/c_1496834279112400896",
          img: "https://cam.lvwzhen.com/project/apple-wiki.png",
        },
        {
          url: "https://bdd2022.com/",
          img: "https://cam.lvwzhen.com/project/bdd2022.png",
        },
        {
          url: "https://cam.lvwzhen.com/",
          img: "https://cam.lvwzhen.com/project/mi-cam.png",
        },
        {
          url: "https://mi-logo.lvwzhen.com/",
          img: "https://cam.lvwzhen.com/project/mi-logo.png",
        },
        {
          url: "https://sharenote.app/",
          img: "https://cam.lvwzhen.com/project/share-note.png",
        },
      ],
      selected: null,
    };
  },
  created() {
    this.selected = this.randomProject(this.projects);
  },
  methods: {
    randomProject(projects) {
      return projects[Math.floor(Math.random() * projects.length)];
    },
    share: function () {
      this.$copyText(this.msg).then(
        function () {
          Toast("复制成功，快去分享吧！");
        },
        function () {
          Toast("复制失败");
        }
      );
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 1000);
    },
    showTips() {
      this.tipsDialog = true;
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    zoomIn() {
      this.scale += 0.1;
    },
    zoomOut() {
      this.scale -= 0.1;
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatarImg = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    clearAvatar() {
      this.avatarImg = null;
    },
    changeStyle(e) {
      this.text = this.list[e.target.title].text;
      this.img = this.list[e.target.title].img;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    clearImage() {
      this.showImage = false;
      this.showText = true;
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        this.showImage = true;
        this.showText = false;
      };
    },
    maker() {
      var node = document.getElementById("avatarmaker");
      var that = this;
      const scale = 2;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage
        .toPng(node, param)
        .then(function () {
          domtoimage.toPng(node, param).then(function (dataUrl) {
            that.output = dataUrl;
            Toast.clear;
            that.avatarmakerDialog = true;
          });
        })
        .catch(function () {});
    },
    generatorImageDialog() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.maker();
    },
    downloadImage(imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = name || "photo";
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
    generatorImage() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      setTimeout(() => {
        Toast.clear;
      }, 300);
      var that = this;
      var node = document.getElementById("avatarmaker");
      const scale = 2;
      const style = {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
        width: node.offsetWidth + "px",
        height: node.offsetHeight + "px",
      };
      const param = {
        height: node.offsetHeight * scale,
        width: node.offsetWidth * scale,
        quality: 1,
        style,
      };
      domtoimage.toPng(node, param).then(function () {
        domtoimage.toPng(node, param).then(function (dataUrl1) {
          that.downloadImage(dataUrl1, "bdd.png");
        });
      });
    },
  },
  computed: {
    parsedBody() {
      return this.text.replace(/\n/g, "<br>");
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.Mobile = true;
    } else {
      this.Mobile = false;
    }
  },
};
</script>
<style>
.van-uploader__preview-image {
  width: 216px;
  height: 216px;
}
.wx-mp {
  box-shadow: 0 1px 3px #eee;
  border-radius: 5px;
  max-width: 280px;
  overflow: hidden;
  margin: 15px auto;
}
.wx-mp img {
  width: 100%;
  height: auto;
  display: block;
}
</style>